import { render, staticRenderFns } from "./stats-fishing.vue?vue&type=template&id=3d19fd9a"
import script from "./stats-fishing.vue?vue&type=script&lang=js"
export * from "./stats-fishing.vue?vue&type=script&lang=js"
import style0 from "./stats-fishing.vue?vue&type=style&index=0&id=3d19fd9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports